import { createQueryHook } from '../internal/createQueryHook';
import { holdouts } from '../queries/holdouts';

export const useHoldoutById = createQueryHook(
  ({ projectKey, environmentKey, holdoutId }: { projectKey: string; environmentKey: string; holdoutId: string }) =>
    holdouts.detailById({ projectKey, environmentKey, holdoutId }),
);
